import * as React from 'react';
import { styled } from '@mui/material/styles';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Toolbar from '@mui/material/Toolbar';
import AppBar from '@mui/material/AppBar';
import { useNavigate, useLocation } from 'react-router-dom';

const StyledTabs = styled((props) => (
  <Tabs
    {...props}
    TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
  />
))({
  '& .MuiTabs-indicator': {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
  },
  '& .MuiTabs-indicatorSpan': {
    maxWidth: 40,
    width: '100%',
    backgroundColor: '#635ee7',
  },
});

const StyledTab = styled((props) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    textTransform: 'none',
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(15),
    marginRight: theme.spacing(1),
    '&.Mui-focusVisible': {
      backgroundColor: 'rgba(100, 95, 228, 0.32)',
    },
  })
);

export default function NavBar() {
  const navigate = useNavigate();
  const location = useLocation();

  const tabPaths = [
    '/',
    '/stevens',
    '/crystal',
    '/snoqualmie',
    '/baker',
    '/paradise',
  ];
  const activeTabIndex = tabPaths.indexOf(location.pathname);

  const handleChange = (event, newValue) => {
    navigate(tabPaths[newValue]);
  };

  return (
    <AppBar position="static" color="white" elevation={1}>
      <Toolbar variant="dense" color="white">
        <Typography component="div" mr={2}>
          What&apos;s the weather?
        </Typography>

        <Box sx={{ flexGrow: 1 }} />

        <StyledTabs
          value={activeTabIndex === -1 ? 0 : activeTabIndex}
          onChange={handleChange}
        >
          <StyledTab label="Overview" />
          <StyledTab label="Stevens" />
          <StyledTab label="Crystal" />
          <StyledTab label="Snoqualmie" />
          <StyledTab label="Baker" />
          <StyledTab label="Paradise" />
        </StyledTabs>
      </Toolbar>
    </AppBar>
  );
}
